export default "__VITE_ASSET__q7yF17nP__"